// extracted by mini-css-extract-plugin
export var body = "card-module--body--abbd1";
export var card = "card-module--card--4925c";
export var description = "card-module--description--864af";
export var img = "card-module--img--415ae";
export var title = "card-module--title--6f993";